import _ from "lodash";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

import { ModalDialog, useMount } from "@sportal/cdk";
import {
  DEVICE_NAME_MAX_LENGTH,
  DeviceDialogInput,
  isStringDifferent,
} from "../deviceForm";
import { DeviceNameInput } from "../deviceForm/DeviceNameInput";
import {
  CommonModalFooter,
  CommonModalHeader,
  useForm,
} from "../../../../../components";

import { getLogicalDeviceDetailsById } from "../../../../../store/devices/logicalDeviceDetails/logicalDeviceDetails.selectors";

export function EditInfoDeviceDialog({ modal, devices, deviceId }) {
  const device = useSelector(getLogicalDeviceDetailsById(deviceId));

  const form = useForm(
    {
      name: device.name,
      username: device.username,
    },
    {
      name: isStringDifferent,
      username: isStringDifferent,
    }
  );

  useMount(() => {
    const error =
      device.username.length >= DEVICE_NAME_MAX_LENGTH
        ? "name_exceed_length"
        : null;
    form.setError("username", error);
  });

  const close = () => modal.reject();
  const submit = () => modal.resolve(_.mapValues(form.getChanges(), _.trim));

  const inputChangeHandler = (name) => (value, error) => {
    form.set(name, value);
    form.setError(name, error);
  };

  const onDeviceNameChangeHandler = (username) => {
    const error = _.isEmpty(username.trim()) ? "username_required" : null;
    form.set("username", username);
    form.setError("username", error);
  };

  return (
    <ModalDialog
      submitHandler={submit}
      rejectHandler={close}
      disabled={!form.didFormChange() || form.hasErrors()}
    >
      <CommonModalHeader>
        <FormattedMessage id="edit_info" />
      </CommonModalHeader>
      <ModalDialog.Body>
        <DeviceNameInput
          device={device}
          devices={devices}
          value={form.values.name}
          handleChange={inputChangeHandler("name")}
          error={form.errors.name}
        />
        <DeviceDialogInput
          label="full_name"
          placeholder="enter_full_name"
          value={form.values.username}
          onChange={onDeviceNameChangeHandler}
          error={form.errors.username}
          maxLength={DEVICE_NAME_MAX_LENGTH}
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck="false"
        />
      </ModalDialog.Body>
      <CommonModalFooter />
    </ModalDialog>
  );
}
